import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ServerConfigState {
  serverUrl: string;
}

const initialState: ServerConfigState = {
  serverUrl: "https://sfa.nitiapp.com/", // default value
};

const ServerConfigSlice = createSlice({
  name: "serverConfig",
  initialState,
  reducers: {
    setServerUrl: (state, action: PayloadAction<string>) => {
      state.serverUrl = action.payload;
    },
  },
});

export const { setServerUrl } = ServerConfigSlice.actions;
export default ServerConfigSlice.reducer;
